import classNames from 'classnames';
import { MenuGroup } from './menu-group';
import { MenuItem } from './menu-item';
// import sidebarBg from '../../../assets/images/sidebar-bg.png';
import { ISystemMenuItem } from '../../../model/system/menu';
import React, { useEffect, useState } from 'react';
// import { SpriteSvg, SpriteSvgType } from '../../../components/sprite-svg';
import { MenuHeader } from './header';
import { getPathnameByGameService, getPathnameByGameInfo } from '../lib';
import { IAPIGameItem, IMyFavoriteItem } from '../../../model/api-modules';
import { GameMenuKey } from '../../../model';
// import AllProductDefault from '../../../assets/svg/all-product-default.svg';
// import AllProductActive from '../../../assets/svg/all-product-active.svg';
import { SvgIconName } from '../../component/svg-icon/model';
import { SvgIcon } from '../../component/svg-icon';
import getFormatMessage from '../../../locales/get-format-message';

interface IProps {
  readonly selectStudio: IAPIGameItem | null;
  readonly onMouseEnter: () => void;
  readonly onMouseLeave: () => void;
  readonly fixedMenu: boolean;
  readonly menus: ReadonlyArray<ISystemMenuItem>;
  readonly myFavoriteList: ReadonlyArray<IMyFavoriteItem>;
  readonly selectedMenuID: string;
  readonly onToRouter: (pathname: string) => void;
  readonly addFavorites: (id: number, status: number) => void;
}
export const GameMenu = (props: IProps) => {
  const [favoriteMenu, setFavoriteMenu] = useState<ISystemMenuItem[]>([]);
  const [openName, setOpenName] = useState<string>('');
  const favoriteList = JSON.parse(JSON.stringify(props.myFavoriteList)).filter(
    (item: IMyFavoriteItem) => {
      return item.Status === 1;
    }
  );

  useEffect(() => {
    getFavoriteMenu();
  }, [props.myFavoriteList]);

  const getFavoriteMenu = () => {
    const favoriteMenu: any = [];
    props.menus.forEach((item) => {
      item.subMenus?.length !== 0 &&
        item.subMenus?.forEach((it) => {
          if (
            favoriteList.find(
              (i: IMyFavoriteItem) => i.ServiceID === Number(it.id)
            )
          ) {
            favoriteMenu.push(it);
          }
        });
    });
    setFavoriteMenu(favoriteMenu);
  };
  const onClickItem = (key: number) => {
    props.onToRouter(getPathnameByGameService(key));
  };

  const renderHeader = () => {
    return (
      <MenuHeader
        selectedMenuID={props.selectedMenuID}
        onToRouter={props.onToRouter}
      />
    );
  };

  const renderMenu = (menu: ISystemMenuItem) => {
    return (
      <MenuGroup
        key={`menu-group-${menu.name}`}
        menu={menu}
        myFavoriteList={favoriteList}
        selectedMenuID={props.selectedMenuID}
        onClickItem={onClickItem}
        addFavorites={props.addFavorites}
        openMenu={openName}
        clickMenu={setOpenName}
      />
    );
  };

  const renderMenuList = () => {
    return props.menus.map((menu) => renderMenu(menu));
  };

  const renderFavoriteMenuList = () => {
    if (favoriteMenu.length === 0) {
      return null;
    }

    return (
      favoriteMenu.length !== 0 &&
      favoriteMenu.map((menu) => {
        return (
          <div className="group-body" key={`favorite-${menu.id}`}>
            <ul className="sidebar-nav">
              <MenuItem
                key={`favorite-${menu.id}`}
                menu={menu}
                myFavoriteList={favoriteList}
                selectedMenuID={props.selectedMenuID}
                isSubMenu
                isFavoriteMenu
                onClickItem={onClickItem}
                addFavorites={props.addFavorites}
              />
            </ul>
          </div>
        );
      })
    );
  };

  const renderAllProduct = () => {
    return (
      <div
        onClick={() =>
          props.onToRouter(getPathnameByGameInfo(GameMenuKey.AllProduct))
        }
        className="all-product"
      >
        <span
          className={classNames(
            'all-product-box',
            props.selectedMenuID === GameMenuKey.AllProduct
              ? 'all-product-active'
              : ''
          )}
        >
          <span className="all-product-icon">
            <SvgIcon
              icon={'all-product' as SvgIconName}
              className={
                props.selectedMenuID === GameMenuKey.AllProduct ? 'active' : ''
              }
            />
          </span>
          <span className="nav-text">{getFormatMessage('all_product')}</span>
        </span>
      </div>
    );
  };

  // const renderBg = () => {
  //   return (
  //     <div className="sidebar-bg">
  //       <img src={sidebarBg} />
  //     </div>
  //   );
  // };

  const className = classNames(
    'gc-console-sidebar',
    props.fixedMenu ? 'fixed' : ''
  );
  return (
    <div
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      className={className}
    >
      <div className="gc-sidebar">
        {/* {renderBg()} */}
        {renderHeader()}
        <div className="sidebar-body">
          {favoriteList.length !== 0 && (
            <div className="categories-title">
              {getFormatMessage('shortcuts')}
            </div>
          )}
          {renderFavoriteMenuList()}
          {favoriteList.length > 0 && <div className="shortcuts-line"></div>}
          <div className="categories-title">
            {getFormatMessage('product_category')}
          </div>
          {renderMenuList()}
          <div className={classNames('all-product-line', 'fixed-none')}></div>
          {renderAllProduct()}
        </div>
      </div>
    </div>
  );
};
